<template>
  <layout :showuserinfo="false" title="Tambah Hak Milik" :crumbs="crumbs">

  <w-card>
    <w-form @submit.prevent="submit">
     <w-flex wrap class="text-center">
      <div class="xs6">

        <div>
             <w-input
                class="mb3"
                label="NEGERI"
                label-position="left"
                placeholder="02 -KEDAH"
                disabled
                style="color:blue;"
                >
            </w-input>
        </div>

        <div>
             <w-select
            class="mb5"
            :items="districts"
            outline
            label="Pilih Daerah"
            label-position="left"
            @input="fetchData1()"
            v-model="form.kod_daerah"
            :validators="[validators.required]"
          >
          </w-select>
        </div>
        <div>
            <w-select
                class="mb5"
                :items="mukim"
                outline
                label="Pilih Mukim"
                label-position="left"
                v-model="form.kod_mukim"
                value="01"
                :validators="[validators.required]"
            />
        </div>
        <div>
            <w-select
                class="mb5"
                :items="jhm"
                outline
                label="Jenis Hakmilik"
                label-position="left"
                v-model="form.kod_jhm"
                :validators="[validators.required]"
            />
        </div>

        <div>
            <w-input
                class="mb5"
                outline
                label="Nombor Hakmilik"
                label-position="left"
                type="text"
                v-model="form.no_hm"
                :validators="[validators.required]"
                >
            </w-input>
        </div>
        <div>
            <w-input
                class="mb5"
                outline
                label="Hakmilik Sebelum Kini"
                label-position="left"
                type="text"
                v-model="form.hm_sbkini"

                >
            </w-input>
        </div>
        <div>
            <w-input
                class="mb5"
                outline
                label="Hakmilik Asal"
                label-position="left"
                type="text"
                v-model="form.hm_asal"

                >
            </w-input>
        </div>
        <div>
            <w-input
                class="mb5"
                outline
                label="Hakmilik Berikut"
                label-position="left"
                type="text"

                v-model="form.hm_berikut"
                >
            </w-input>
        </div>
        <div>
            <w-input
                class="mb5"
                outline
                label="Tarikh Daftar"
                label-position="left"
                type="date"
                v-model="form.tarikh_daftar"
                :validators="[validators.required]"
                >
            </w-input>
        </div>
        <div>
            <w-flex>
                <z-lookup
                class="mb5"
                :url="this.apiBaseUrl + '/jenis-lot'"
                :sort="false"
                :cache="false"
                outline
                label="Kod Lot"
                label-position="left"
                :validators="[validators.required]"
                v-model="form.kod_lot"
            />
            <w-input
                class="mb5"
                outline
                label="No Lot"
                label-position="left"
                type="text"
                v-model="form.no_lot"
                :validators="[validators.required]"
                >
            </w-input>
            </w-flex>
        </div>
        <div>
            <w-flex>
                <z-lookup
                class="mb5"
                :url="this.apiBaseUrl + '/unit-keluasan'"
                :sort="false"
                :cache="false"
                outline
                label="Unit Keluasan"
                label-position="left"
                v-model="form.kod_keluasan"
                :validators="[validators.required]"
            />
            <w-input
                class="mb5"
                outline
                label="Keluasan"
                label-position="left"
                type="text"
                v-model="form.keluasan"
                :validators="[validators.required]"
                >
            </w-input>
            </w-flex>
        </div>
        <div>
             <z-lookup
                class="mb5"
                outline
                label="Kegunaan Tanah"
                label-position="left"
                    :url="apiBaseUrl + '/kegunaan-tanah'"
                    :sort="false"
                    :cache="false"
                 v-model="form.lkp_hm_kegunaan_id"
                 :validators="[validators.required]"
                />
        </div>

      </div>

      <div class="xs6 pa1">
        <div >
             <w-input
                class="mb3"
                label="Nama"
                label-position="left"
                type="text"
                outline
                v-model="form.nama"
                :validators="[validators.required]"
                >
            </w-input>
        </div>
        <div >
                <w-input
                   class="mb3"
                   label="No KP/Passport"
                   label-position="left"
                   type="text"
                   outline
                   v-model="form.no_kp"
                   >
               </w-input>

        </div>
        <div>
            <w-input
                class="mb5"
                label="Alamat 1"
                label-position="left"
                type="text"
                outline
                v-model="form.alamat_1"
                :validators="[validators.required]">
            </w-input>
        </div>
        <div>
            <w-input
                class="mb5"
                label="Alamat 2"
                label-position="left"
                type="text"
                outline
                v-model="form.alamat_2"
                :validators="[validators.required]">
            </w-input>
        </div>
        <div>
            <w-input
                class="mb5"
                label="Alamat 3"
                label-position="left"
                type="text"
                outline
                v-model="form.alamat_3"
                :validators="[validators.required]">
            </w-input>
        </div>
        <div>
             <z-lookup
                class="mb5"
                :url="this.apiBaseUrl + '/poskod'"
                :sort="false"
                :cache="false"
                outline
                label="Poskod"
                label-position="left"
                v-model="form.poskod_kod"
                :validators="[validators.required]"
            />
        </div>

        <div>
            <w-flex>
                <w-input
                class="mb3"
                label="Cukai Tahun Semasa"
                label-position="left"
                type="text"
                outline
                v-model="form.cukai_semasa"
                :validators="[validators.required]">
                </w-input>
            </w-flex>
        </div>
        <div>
            <w-flex>
                <w-input
                class="mb3"
                label="Cukai Lama"
                label-position="left"
                type="number"
                outline
                v-model="form.cukai_lama"

                >
                </w-input>
                <w-input
                class="mb3"
                label="Cukai Parit Tali Air"
                label-position="left"
                type="number"
                outline
                v-model="form.cukai_parit"
                >
                </w-input>
            </w-flex>
        </div>
        <div>
             <z-lookup
                    class="mb5"
                    :url="apiBaseUrl + '/status-hm'"
                    :sort="false"
                    :cache="false"
                    v-model="form.lkp_hm_status_id"
                    label="Status Hakmilik"
                    outline
                    label-position="left"
                    :validators="[validators.required]"
                />
        </div>
            <div class="d-flex justify-end mt3">
              <w-button class="my1 mr0" type="submit" :loading="searching">
                Tambah Hakmilik
              </w-button>
            </div>
      </div>
    </w-flex>
    </w-form>
  </w-card>
  </layout>
</template>
<script>
import ZResource from "@/Modules/z-resource";
import { Inertia } from "@inertiajs/inertia";
export default {
  extends: ZResource,

  data(){
    return {
        validators: {required: (value) => !!value || "Sila Isi Ruangan Ini",},
        districts: [{ label: "Loading", selected: true }],
        mukim: [{ label: "Loading", selected: true }],
        jhm: [{ label: "Loading", selected: true }],
        kod_lot: [{ label: "Loading", selected: true }],
        apiBaseUrl: process.env.MIX_API_BASE_URL,
        searching: false,
        form: {
            kod_daerah: "01",
            kod_mukim: null,
            kod_jhm:null,
            no_hm:null,
            hm_sbkini:null,
            hm_asal:null,
            hm_berikut:null,
            tarikh_daftar:null,
            kod_lot: null,
            no_lot:null,
            kod_keluasan:null,
            keluasan:null,
            nama:null,
            no_kp:null,
            alamat_1:null,
            alamat_2:null,
            alamat_3:null,
            poskod_kod:null,
            cukai_semasa:null,
            cukai_lama:null,
            cukai_parit:null,
            lkp_hm_kegunaan_id:null,
            lkp_hm_status_id:null,

        },
        renderComponent: false,
        jhm: [{ label: "Loading", selected: true }],
    }
  },
  methods:{
     async submit() {
        this.searching = true;
        await axios({
          method: "post",
          url: `${this.apiBaseUrl}/cukai/tambah_hm`,
          responseType: "json",
          data: this.form,
        }).then((e)=>{
            console.log(e.data);
const url = `butiran-cukai?no_hm=${e.data}`;
            //   console.log(url);
            this.$inertia.get(url);
        }).finally((e) => {
            this.searching = false;

          });
    },

    async fetchData() {
      await axios({
        method: "get",
        url: `${this.apiBaseUrl}/daerah`,
        responseType: "json",
      }).then((e) => {
        this.districts = e.data.map((d) => {
          return {
            label: d.kod + " - " + d.keterangan,
            value: d.kod,
          };
        });
      });
    },

     async fetchData1(w) {
      await axios({
        method: "get",
        url: `${this.apiBaseUrl}/daerah/${this.form.kod_daerah}/mukim`,
        responseType: "json",
      }).then((e) => {
        this.mukim = e.data.map((d) => {
          return {
            label: d.kod + " - " + d.keterangan,
            value: d.id,
          };
        });
      });
    },


    async fetchData2() {
      await axios({
        method: "get",
        url: `${this.apiBaseUrl}/jenisHm`,
        responseType: "json",
      }).then((e) => {
        this.jhm = e.data.map((d)=>{
            return {
                label: d.kod +" - " + d.keterangan,
                value:d.id,
            };
        });
      });
    },

    async fetchData3() {
      await axios({
        method: "post",
        url: `${this.apiBaseUrl}/jenis-lot`,
        responseType: "json",
      }).then((e) => {
        console.log(e)
        this.kod_lot = e.data
      });
    },

  },
mounted() {
    this.fetchData();
    this.fetchData1();
    this.fetchData2();
    this.fetchData3();

  },
};
</script>
